import { markGameRootEntryAllowed } from '../utils/sessionExpiration'

/**
 * Session-only ack: new tab shows install vs continue; closing the tab clears this.
 */
export const PWA_ENTRY_SESSION_ACK_KEY = 'eclipsera.pwaEntry.sessionAck'

export function isPwaEntrySessionAcked(): boolean {
  try {
    return sessionStorage.getItem(PWA_ENTRY_SESSION_ACK_KEY) === '1'
  } catch {
    return false
  }
}

/** After PWA gate choice, allow main `/` without forcing `/start` (same role as Enter on Start). */
export function ackPwaEntrySession(): void {
  try {
    sessionStorage.setItem(PWA_ENTRY_SESSION_ACK_KEY, '1')
  } catch {
    /* private mode */
  }
  markGameRootEntryAllowed()
}
